/** Small, dependency-free helpers shared across the AI Picks flow. */

/** Promise that resolves after `ms` milliseconds. */
export const sleep = (ms: number) =>
  new Promise<void>((resolve) => window.setTimeout(resolve, ms));

/** Current hour (0–23) in the given IANA timezone, or `null` if unavailable. */
export const getHourForTimezone = (timezone: string): number | null => {
  try {
    const formatter = new Intl.DateTimeFormat("en-GB", {
      hour: "numeric",
      hour12: false,
      timeZone: timezone,
    });
    const parts = formatter.formatToParts(new Date());
    const hourPart = parts.find((part) => part.type === "hour");
    return hourPart ? Number(hourPart.value) : null;
  } catch {
    return null;
  }
};

/** Map an Open-Meteo weather code to a coarse bucket the backend understands. */
export const weatherCodeToBucket = (weatherCode: number): string => {
  if (weatherCode === 0) return "sunny";
  if (weatherCode === 1) return "clear";
  if ([2, 3, 45, 48, 71, 73, 75, 77, 85, 86].includes(weatherCode))
    return "cloudy";
  return "rainy";
};
